import { SafeResourceUrl } from "@angular/platform-browser";
import { BaseModel } from "src/app/core/models/base.model"
import { BusinessUnit } from "../../org/bussiness-unit.model";
import { LoginProviderEnum } from "src/app/core/enums/login-provider-enum";
import { AccountTypeEnum } from "src/app/core/enums/account-type-enum";


export class UserBaseModel extends BaseModel {
    userName?: string;
    fullName?: string;
    name: string = "";
    lastName: string = "";
    email: string = "";
    enabled?: boolean;
    status?: number;
    profilePhotoFileId?: string;
    coverPhotoFileId?: string;
    isEmailVerified?: boolean;
    businessUnitId?: string;
    roles?: string[] = [];
    lastActive?: Date;
    businessUnit?: BusinessUnit;
    //Oauth Registration Info
    loginProvider?: LoginProviderEnum =  LoginProviderEnum.Native;
    socialId?: string;
    accountType?: AccountTypeEnum = AccountTypeEnum.Standard;

    //these ones are for Website only:
    listPhoto?: SafeResourceUrl;
    isOnline: boolean = false;
    isInList: boolean = false;
}
